const baseEndpoint = '/dashboard';
const publicEndpoint = baseEndpoint + '/public';
export default {
  GET_NUMBER_OF_VIEWS: {
    url: `${baseEndpoint}/number-of-view`,
    method: 'GET'
  },
  GET_NUMBER_OF_UNIQUE_VISITOR: {
    url: `${baseEndpoint}/unique-visitor-view`,
    method: 'GET'
  },
  GET_VIEWS_PER_SECTION: {
    url: `${baseEndpoint}/view-per-section`,
    method: 'GET'
  },
  GET_TOP_50_SEARCH_TERMS: {
    url: `${baseEndpoint}/top-search-keywords`,
    method: 'GET'
  },
  UPDATE_VIEW: {
    url: `${publicEndpoint}/update-view`,
    method: 'PUT'
  },
  UPDATE_SECTION_VIEW: {
    url: `${publicEndpoint}/update-view-per-section`,
    method: 'PUT'
  },
  UPDATE_UNIQUE_VISITOR: {
    url: `${publicEndpoint}/update-unique-visitor`,
    method: 'PUT'
  }
};
